module.exports = __webpack_public_path__ + "img/hero-check-red.ba60a293.svg";